/* CardX Redesign – Filter & Sortierung ohne Neuladen (Section Rendering API, ohne Bibliotheken) */
(() => {
  'use strict';

  const T = window.CXTheme;
  const root = document.querySelector('[data-cx-facets]');
  if (!T || !root) return;

  const sectionId = root.dataset.sectionId;
  /* Basis ist der aktuelle Pfad, damit eine gewählte Produktart (Tag im Pfad, z. B. /collections/pokemon/display)
     bei Filtern und Sortierung erhalten bleibt. Fallback: data-url. */
  const baseUrl0 = root.dataset.url || window.location.pathname;
  const baseUrl = () => {
    const path = window.location.pathname;
    return path === baseUrl0 || path.indexOf(baseUrl0 + '/') === 0 ? path : baseUrl0;
  };
  const cache = new Map();
  let controller;
  let timer;

  const panelEl = document.getElementById('cx-filters');
  const sheet = panelEl ? T.panel(panelEl, T.$$('[data-cx-filter-open]'), { useHidden: false, focus: 'input, select, button' }) : null;

  /* ---- Preissortierung: Shopify sortiert nach dem günstigsten Variantenpreis (auch ausverkauft).
     Die Karten zeigen den günstigsten lieferbaren Preis – innerhalb der Seite wird danach geordnet. */
  const sortGrid = () => {
    const grid = root.querySelector('[data-cx-grid]');
    if (!grid) return;
    const mode = grid.dataset.sort;
    if (mode !== 'price-ascending' && mode !== 'price-descending') return;
    const dir = mode === 'price-ascending' ? 1 : -1;
    const items = Array.from(grid.children).map((li, index) => {
      const card = li.querySelector('[data-cx-price]');
      return { li, index, price: card ? Number(card.dataset.cxPrice) : 0 };
    });
    items.sort((a, b) => (a.price - b.price) * dir || a.index - b.index);
    items.forEach((item) => grid.appendChild(item.li));
  };

  /* ---- Produktarten-Leiste (mobil scrollbar): aktive Schaltfläche in den sichtbaren Bereich holen. */
  const showActiveType = () => {
    const list = root.querySelector('.cx-types__list');
    const act = list ? list.querySelector('.cx-type.is-active') : null;
    if (!list || !act || list.scrollWidth <= list.clientWidth) return;
    const offset = act.getBoundingClientRect().left - list.getBoundingClientRect().left;
    if (offset < 0 || offset + act.offsetWidth > list.clientWidth) list.scrollLeft += offset - 16;
  };

  const buildUrl = () => {
    const form = document.getElementById('cx-filter-form');
    let params;
    if (form) {
      params = new URLSearchParams(new FormData(form));
    } else {
      params = new URLSearchParams(window.location.search);
      const sort = root.querySelector('[data-cx-sort]');
      if (sort) params.set('sort_by', sort.value);
    }
    Array.from(params.keys()).forEach((key) => {
      if (params.getAll(key).every((v) => v === '')) params.delete(key);
    });
    params.delete('page');
    const query = params.toString();
    return baseUrl() + (query ? '?' + query : '');
  };

  const replaceRegions = (doc) => {
    T.$$('[data-cx-region]', root).forEach((el) => {
      const name = el.dataset.cxRegion;
      const fresh = doc.querySelector('[data-cx-region="' + name + '"]');
      if (!fresh) return;
      if (name === 'body') {
        const open = {};
        T.$$('details[data-cx-filter]', el).forEach((d) => (open[d.dataset.cxFilter] = d.open));
        const active = document.activeElement;
        const focusKey = active && el.contains(active) && active.name ? active.name + '|' + active.value : null;
        el.innerHTML = fresh.innerHTML;
        T.$$('details[data-cx-filter]', el).forEach((d) => {
          if (d.dataset.cxFilter in open) d.open = open[d.dataset.cxFilter];
        });
        if (focusKey) {
          const match = T.$$('input', el).find((i) => i.name + '|' + i.value === focusKey) || T.$$('input', el).find((i) => i.name === focusKey.split('|')[0]);
          if (match) match.focus({ preventScroll: true });
        }
      } else {
        el.innerHTML = fresh.innerHTML;
      }
    });
    const freshGrid = doc.querySelector('[data-cx-grid]');
    const grid = root.querySelector('[data-cx-grid]');
    if (grid && freshGrid) grid.dataset.sort = freshGrid.dataset.sort;
    sortGrid();
    showActiveType();
    T.initMediaTone(root);
  };

  const render = async (url, { push = true, scroll = false } = {}) => {
    const key = url;
    const main = root.querySelector('.cx-collection__main');
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    if (main) main.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');
    try {
      let html = cache.get(key);
      if (!html) {
        const sep = url.indexOf('?') === -1 ? '?' : '&';
        const res = await fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), controller ? { signal: controller.signal } : {});
        if (!res.ok) throw new Error(String(res.status));
        html = await res.text();
        cache.set(key, html);
      }
      replaceRegions(new DOMParser().parseFromString(html, 'text/html'));
      if (push) window.history.pushState({ cxFacets: true }, '', url);
      if (scroll) {
        const target = document.getElementById('cx-results');
        if (target) target.scrollIntoView({ behavior: T.reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    } catch (e) {
      if (e.name !== 'AbortError') window.location.href = url;
    } finally {
      if (main) main.classList.remove('is-loading');
      root.removeAttribute('aria-busy');
    }
  };

  root.addEventListener('change', (event) => {
    const t = event.target;
    if (t.matches('[data-cx-sort]')) {
      const grid = root.querySelector('[data-cx-grid]');
      if (grid) grid.dataset.sort = t.value;
      render(buildUrl());
      return;
    }
    if (!t.closest('[data-cx-filter-form]') || t.matches('input[type="number"]')) return;
    render(buildUrl());
  });

  root.addEventListener('input', (event) => {
    if (!event.target.matches('[data-cx-filter-form] input[type="number"]')) return;
    clearTimeout(timer);
    timer = setTimeout(() => render(buildUrl()), 800);
  });

  root.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-cx-filter-form]')) return;
    event.preventDefault();
    render(buildUrl());
  });

  root.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-cx-facets-link]');
    if (!link || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    const isPage = Boolean(link.closest('.cx-pagination'));
    render(link.getAttribute('href'), { scroll: isPage });
  });

  window.addEventListener('popstate', () => render(window.location.pathname + window.location.search, { push: false }));

  sortGrid();
  showActiveType();
  if (document.readyState !== 'complete') window.addEventListener('load', showActiveType, { once: true });
  if (sheet) root.dataset.cxSheet = '1';
})();